import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { UrlUtils } from '@atlassian/mpac-utils';
import * as Immutable from 'immutable';
import isEmpty from 'lodash/isEmpty';
import { promotionsRoute } from "../../../../constants/Routes";
import { resolveManagePartnersRoutes } from "../../../../utils/routeUtils";
import { ELIGIBLE_APPS_HOSTING_TYPE_MISMATCH_ERROR, ELIGIBLE_APPS_MISMATCH_ERROR, FIELD_EMPTY_ERROR } from "../constants";
export const validateSameHostingAndProduct = (eligibleApps, hostingType, partnerAppsAndHosting) => {
  let filteredApps = partnerAppsAndHosting.apps.filter(app => eligibleApps.some(selectedApp => selectedApp.value === app.key) && app.compatibleProducts.map(product => product.hostingType).includes(hostingType.value));

  if (filteredApps.length !== eligibleApps.length) {
    return ELIGIBLE_APPS_HOSTING_TYPE_MISMATCH_ERROR;
  }

  const intendedProduct = filteredApps[0].compatibleProducts.find(compatibleProduct => compatibleProduct.hostingType === hostingType.value);

  if (intendedProduct) {
    filteredApps = filteredApps.filter(app => app.compatibleProducts.some(compatibleProduct => compatibleProduct.product === intendedProduct.product && compatibleProduct.hostingType === intendedProduct.hostingType));
  }

  if (filteredApps.length !== eligibleApps.length) {
    return ELIGIBLE_APPS_MISMATCH_ERROR;
  }
};
export const validateEligibleApps = (eligibleApps, hostingType, partnerAppsAndHosting) => {
  if (!eligibleApps) {
    return FIELD_EMPTY_ERROR;
  }

  if (hostingType) {
    return validateSameHostingAndProduct(eligibleApps, hostingType, partnerAppsAndHosting);
  }
};
export const validateEmptyField = value => {
  var _isEmpty;

  return (_isEmpty = isEmpty(value)) !== null && _isEmpty !== void 0 ? _isEmpty : FIELD_EMPTY_ERROR;
};
export const gotoPromotionsListPage = (history, parameters, promotion, action) => history.push(_objectSpread({
  pathname: resolveManagePartnersRoutes(promotionsRoute.path, parameters)
}, promotion && {
  search: UrlUtils.resolveSearchFromImmutableQuery(Immutable.Map({
    promotion,
    action
  }))
}));